'use client';

import { Suspense, useMemo } from 'react';
import { DataTableActions } from '@/components/Shared/DataTableActions';
import { DataTableWrapper } from '@/components/Shared/DataTableWrapper';
import { DataTable } from '@/components/ui/data-table';
import { useTableStatistics } from '@/hooks/swr/useTableStatistics';
import { Dataset } from '@/lib/types/Dataset';
import { Table } from '@/lib/types/Table';
import { TableStats } from '@/lib/types/TableStats';
import { combineColumnStatistics } from '../statisticsHelper';
import { TableSummarySkeleton } from './TableSummarySkeleton';
import { columns } from './summaryColumns';
interface TableActionSummaryProps {
  dataset: Dataset;
  table: Table;
}
export function TableSummary({
  dataset,
  table
}: TableActionSummaryProps) {
  const {
    data: tableStatistics,
    isLoading
  } = useTableStatistics(dataset.id, table.id);
  const data = useMemo(() => combineColumnStatistics({
    tableColumns: table.columns,
    tableStatistics
  }), [table.columns, tableStatistics]);
  const dataTable = useMemo(() => <DataTable columns={columns} data={data as any} />, [data]);
  if (isLoading) {
    return <TableSummarySkeleton length={Object.keys(table.columns).length} />;
  }
  return <Suspense fallback={<TableSummarySkeleton length={Object.keys(table.columns).length} />}>
      <div>
        <DataTableWrapper>{dataTable}</DataTableWrapper>
        <DataTableActions fullscreenDialogContent={dataTable} fullscreenDialogTitle="Summary" fullscreenDialogDescription={'Summary of columns and their statistics on this table. Hover truncated values to see the full value.'} />
      </div>
    </Suspense>;
}